export default __webpack_public_path__ + "static/media/viva-logo-white.baaf7aff.svg";